var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, stringDecoder, PICAction, PICPicker, PICDate, PICDualDate } from '../../Internals';
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
import { styleMap } from 'lit/directives/style-map.js';
import { property, state } from "lit/decorators.js";
import { html, css } from "lit";
let PICDatePicker2 = class PICDatePicker2 extends PICPicker {
    set data(data) {
        var _a;
        this.curDispDate_ = new Date(data.startDate);
        this.startDate = data.startDate;
        if (data.parent) {
            this.parent_ = data.parent;
        }
        if (data.parent instanceof PICDate && data.parent.value == data.parent.getBlankValue())
            this.initStart = null;
        else
            this.initStart = new Date(this.startDate);
        this.endDate = data.endDate;
        this.initEnd = this.endDate ? new Date(this.endDate) : null;
        this.clickedDate_ = null;
        this.markRanges_ = data.markRanges;
        (_a = this.markRanges_) === null || _a === void 0 ? void 0 : _a.forEach(mr => {
            if (!mr.clickable) {
                this.blockingRanges_.push(mr);
            }
        });
        this.infoText = data.infoText;
        this.requestUpdate();
    }
    constructor() {
        super();
        this.hasWeekNo_ = false;
        this.removeClearBtn_ = false;
        this.show = "hidden";
        this.state_ = 'day';
        this.dateSelectionMode_ = 'one';
        this.calendarDisplayMode_ = 'single';
        this.dateCandidates = [];
        this.years = [];
        this.blockingRanges_ = [];
        this.curDispDate_ = new Date(Date.now());
        this.clickedDate_ = null;
        this.hoveredDate_ = null;
        this.startDate = new Date();
        this.endDate = new Date();
        this.infoText = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.clearAction = new PICAction('internal', this.handleClear.bind(this));
        this.cancelAction = new PICAction();
        this.saveAction = new PICAction();
        if (!this.textObj) {
            this.textObj = {
                clearAction: 'Clear',
                cancelAction: 'Cancel',
                confirmAction: 'Ok',
                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                weekdays: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"]
            };
        }
        for (let i = 1900; i < (new Date().getFullYear() + 32); i++) {
            this.years.push(i.toString());
        }
    }
    firstUpdated() {
        this.cancelAction.type_ = 'internal';
        this.cancelAction.eventFnc = this.handleCancel.bind(this);
        this.handleClose.bind(this);
        this.saveAction.type_ = 'internal';
        this.saveAction.eventFnc = this.handleSave.bind(this);
        this.clearAction.type_ = 'internal';
        this.clearAction.eventFnc = this.handleClearDate.bind(this);
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --pic-datePickerSelectColor: var(--pic-primaryColor);
            --pic-datePickerClickedColor: var(--pic-datePickerSelectColor)
            --pic-datePickerSelectTextColorDark: var(--pic-onSurfaceHighColor);
            --pic-datePickerSelectTextColorLight: var(--pic-onPrimaryHighColor);
            --pic-datePickerRangeColor: var(--pic-primaryFocusColor);
            --pic-datePickerBackgroundColor: var(--pic-onPrimaryHighColor);
            --pic-datePickerControlsColor: var(--pic-onSurfaceMediumColor);
            --pic-datePickerWeekDayHeaderColor: var(--pic-onSurfaceDisabledColor);
            --pic-scrollbarTrackColor: var(--pic-onPrimaryHighColor);
            --pic-datePickerWeekNoBordercolor: var(--pic-surfaceOverlayDraggedColor);
            --pic-datePickerHoverColor: var(--pic-outline)
        }
        .calendar_container{
            height: 324px;
            width: 256px;
            background-color: var(--pic-datePickerBackgroundColor);
            box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
            padding-left: 7px;
            padding-right: 7px;
            overflow: hidden;
        }
        .calendar_container.hasweekno{
            width: 274px;
        }
        .header,.footer{
            height: 15%;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .header{
            justify-content: space-between;
        }
        .footer{
            justify-content: center;
        }
        .body {
            height: 70%;
            overflow-y: scroll;
        }
        .today {
            background-color: var(--pic-datePickerSelectTextColorLight); 
            border-color: var(--pic-datePickerSelectTextColorDark);
            color: var(--pic-datePickerSelectTextColorDark);
            border-width: 1px;
            border-style: solid;
            z-index: 2;
        }
        .selected {
            background-color: var(--pic-datePickerSelectColor);
            color: var(--pic-datePickerSelectTextColorLight);
            font-weight: bold;
            z-index: 2;
        }
        .clicked {
            background-color: var(--pic-datePickerSelectColor);
            color: var(--pic-datePickerSelectTextColorLight);
            font-weight: bold;
        }
        .range {
            background-color: var(--pic-datePickerRangeColor);
            border-radius: 14px 14px 14px 14px;
            z-index: 1;
        }
        /*.hovered {
            border-radius: 14px 14px 14px 14px;
        }*/
        .outer.hoverend{
            border-top-right-radius: 14px;
            border-bottom-right-radius: 14px;
            border-right-width: 1px;
        }
        .outer.hoverstart{
            border-top-left-radius: 14px;
            border-bottom-left-radius: 14px;
            border-left-width: 1px;
        }
        .outer.hovered{
            border-color: var(--pic-datePickerHoverColor);
        }
        .outer{
            border-width: 1px 0px;
            border-style: solid;
            border-color: transparent;
        }
        .range.mark {
            background-color: attr(data-color);
            mix-blend-mode: multiply;
            z-index: 2;
        }
        .range.clickthrough {
            pointer-events: none;
        }
        .rangedrag{

        }
        .month_year_display{
            cursor: pointer;
        }
        .month_year_display.arrowdown::after, .month_year_display.arrowup::after, .month_next::before, .month_previous::before{
            font-family: "Material Design Icons";
            font-size: x-large;
            color: var(--pic-datePickerControlsColor);
            cursor: pointer;
        }
        .month_previous::before{
            content: '\u{F0141}';
            font-weight:bold;
        }
        .month_year_display.arrowdown::after{
            content: '\u{F035D}';
        }
        .month_year_display.arrowup::after{
            content: '\u{F0360}';
        }
        .month_next::before{
            content: '\u{F0142}';
            font-weight:bold;
        }
        .year_grid_container{
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            padding-left: 10px;
            padding-right: 10px;
        }
        .year{
            border-radius: 32px;
            height: 28px;
            width: 56px;
            text-align: center;
            line-height: 28px;
        }
        .year:not(.selected), .weekday:not(.blocked){
            cursor: pointer;
        }
        .day_grid_container{
            display: grid;
            padding-left: 10px;
            padding-right: 10px;
            grid-row-gap: 4px;
        }
        .weekday_header{
            color: var(--pic-datePickerWeekDayHeaderColor);
        }
        .weekday{
            width: 28px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            border-radius: 32px;
            justify-self: center;
            z-index: 3;
        }
        .weekday-disabled, .weekday-disabledA {
            background-color: var(--pic-outline, #f0f0f0);
            color: var(--pic-onSurfaceMediumColor, #888);
            opacity: 0.5;
        }
        .weekno{
            width: 28px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            border-radius: 32px;
            color: var(--pic-datePickerWeekDayHeaderColor);
        }
        .border{
            width: 1px;
            background-color: var(--pic-datePickerWeekNoBordercolor);
        }
        .pic-tooltip{
                position: relative;
            }
        .pic-tooltip:before{
            content: attr(data-tooltip);
            position: absolute;
            pointer-events: none;

            white-space: pre-wrap;
            word-wrap: break-word;

            font-family: 'Montserrat';
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.4px;
            color: var(--pic-onSurfaceHighColor);
            
            z-index: 5;
            opacity: 0;
            
            top: 50%;
            transform: translateY(-50%);
            
            left: 100%;
            margin-left: 15px;
            
            width: 200px; 
            padding: 10px;
            border-radius: 4px;
            background: var(--pic-primaryColor);
            color: var(--pic-onPrimaryHighColor);
            text-align: center; 
            
            visibility: hidden;
        }
        .pic-tooltip:after{
            content: '';
            position: absolute;
            pointer-events: none;
            
            z-index: 5;
            opacity: 0;
            
            left: 100%;
            margin-left: -5px;
            
            top: 50%;
            transform: translateY(-50%);
            
            border: 10px solid var(--pic-primaryColor);
            border-color: transparent var(--pic-primaryColor) transparent transparent;
            
            visibility: hidden;
        }
        .picker.new{
            position: fixed;
            top: var(--pic-dpHeight, 0px)
        }
        .pic-tooltip:before, .pic-tooltip:after{
            -webkit-transition: all .5s ease-out .5s;
            -moz-transition: all .5s ease-out .5s;
            -ms-transition: all .5s ease-out .5s;
            -o-transition: all .5s ease-out .5s;
            transition: all .5s ease-out .5s;
            isolation: isolate;
        }
        .pic-tooltip:hover:not(.picker):before, .pic-tooltip:hover:not(.picker):after{
            visibility: visible;
            opacity: 1;
        }
        
        .pic-tooltip.left:before{
            left: initial;
            margin: initial;

            right: 100%;
            margin-right: 15px;
        }
        .pic-tooltip.top:before{
            top: initial;
            transform: translateY(50%);
        }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    handleClearDate(e) {
        let bubblingEvent = { detail: { date: this.startDate, clickEvent: e, type: 'clear' }, bubbles: true, composed: true };
        this.parent_.inputField.value = '';
        this.dispatchEvent(new CustomEvent('valueselected', bubblingEvent));
        this.handleClose();
    }
    handleSave(e) {
        if (this.state_ == 'year') {
            this.state_ = 'day';
            this.requestUpdate();
        }
        else {
            let bubblingEvent = { detail: { date: this.startDate, clickEvent: e, type: 'select' }, bubbles: true, composed: true };
            this.dispatchEvent(new CustomEvent('valueselected', bubblingEvent));
            this.handleClose();
        }
    }
    handleCancel(e) {
        if (this.state_ == 'year') {
            this.state_ = 'day';
            this.curDispDate_.setFullYear(this.oldYear);
            this.requestUpdate();
        }
        else {
            let bubblingEvent;
            if (this.dateSelectionMode_ == 'one') {
                bubblingEvent = { detail: { date: this.initStart, clickEvent: e, type: 'cancel' }, bubbles: true, composed: true };
            }
            else if (this.dateSelectionMode_ == 'range') {
                bubblingEvent = { detail: { dates: [this.initStart, this.initEnd], clickEvent: e, type: 'cancel' }, bubbles: true, composed: true };
            }
            this.dispatchEvent(new CustomEvent('valueselected', bubblingEvent));
            this.handleClose();
        }
    }
    hideEvent() {
        if (this.dateSelectionMode_ == 'range') {
            let bubblingEvent = { detail: { type: 'close' }, bubbles: true, composed: true };
            this.dispatchEvent(new CustomEvent('pickerclosed', bubblingEvent));
        }
    }
    handleClose() {
        this.hideEvent();
        this.toggle();
        this.requestUpdate();
    }
    setDispYear(iYear) {
        this.curDispDate_.setFullYear(parseInt(iYear));
        this.requestUpdate();
    }
    modifyDispMonth(iChange) {
        this.curDispDate_.setDate(1);
        this.curDispDate_.setMonth(this.curDispDate_.getMonth() + iChange);
        this.requestUpdate();
    }
    getPickerClass() {
        return {
            picker: true,
            new: true,
            calendar_container: true,
            show: this.show == 'show',
            hidden: this.show == 'hidden',
            fade: this.show == 'fade',
            hasweekno: this.hasWeekNo_,
            'pic-body2': true
        };
    }
    renderHeader() {
        return html `
            <div class=${classMap(this.getMonthPrev())} @click=${() => { this.modifyDispMonth(-1); }}></div>
            <div class=${classMap(this.getDisplayClass())} @click=${this.flipState}>
                ${this.textObj.months[this.curDispDate_.getMonth()]} ${this.curDispDate_.getFullYear().toString()}
            </div>
            <div class=${classMap(this.getMonthNext())} @click=${() => { this.modifyDispMonth(1); }}></div>
        `;
    }
    flipState() {
        if (this.state_ == 'year')
            this.state_ = 'day';
        else {
            this.state_ = 'year';
            this.oldYear = this.curDispDate_.getFullYear();
        }
        this.requestUpdate();
    }
    getMonthPrev() { return { month_previous: this.state_ !== 'year' }; }
    getMonthNext() { return { month_next: this.state_ !== 'year' }; }
    getDisplayClass() {
        return {
            month_year_display: true,
            arrowdown: this.state_ !== 'year',
            arrowup: this.state_ == 'year'
        };
    }
    toggle() {
        super.toggle();
    }
    renderBody() {
        if (this.state_ == 'year')
            return html `${this.renderYearPicker()}`;
        else
            return html `${this.renderDayPicker()}`;
    }
    renderDayPicker() {
        return html `
            <div class="day_grid_container base-center" style=${styleMap(getHeaderStyle(this.hasWeekNo_))}>
                ${this.renderWeekDayHeaders()}
                ${this.renderWeekDays()}
            </div>
        `;
        function getHeaderStyle(iWeekNo) {
            return {
                'grid-template-columns': (iWeekNo ? '32px 1px ' : '') + 'repeat(7, 32px);'
            };
        }
    }
    renderWeekDayHeaders() {
        let weekdays = this.textObj.weekdays;
        if (this.hasWeekNo_ && weekdays[0] !== '#') {
            weekdays.unshift('');
            weekdays.unshift('#');
        }
        return html `${repeat(weekdays, (weekDay) => weekDay, (weekDay, index) => renderWeekDayHeader(weekDay, index))}`;
        function renderWeekDayHeader(iWeekDay, iIdx) {
            return html `<div class="weekday_header" style="grid-area: ${1} / ${iIdx + 1} / ${2} / ${iIdx + 2};">${iWeekDay}</div>`;
        }
    }
    renderWeekDays() {
        let res = [];
        let curYear = this.curDispDate_.getFullYear();
        let curMonth = this.curDispDate_.getMonth();
        let firstWeekDayMonth = new Date(curYear, curMonth, 1).getDay();
        //adjust for sunday being last instead of first
        firstWeekDayMonth = (firstWeekDayMonth === 0) ? 7 : firstWeekDayMonth;
        let totalDays = new Date(curYear, curMonth + 1, 0).getDate();
        let curWeekDay = (firstWeekDayMonth == 1) ? 1 : firstWeekDayMonth;
        // row counter, offset for header
        let row = 2;
        let currentWeekNo;
        let firstCol = 1;
        //extra columns if showing weekno
        let columns = this.hasWeekNo_ ? 9 : 7;
        if (this.hasWeekNo_) {
            currentWeekNo = new Date(curYear, curMonth, 1).getWeek();
            curWeekDay += 2;
            firstCol = 3;
        }
        let rowDayArr = Array(curWeekDay - firstCol).fill(undefined);
        for (let day = 1; day < (totalDays + 1); day++) {
            rowDayArr.push(new Date(curYear, curMonth, day));
            res.push(this.renderWeekDay(day, curWeekDay, row, rowDayArr[rowDayArr.length - 1], firstCol, columns));
            // each row
            if (curWeekDay === columns) {
                curWeekDay = firstCol;
                if (this.dateSelectionMode_ == 'range') {
                    res.push(handleRange(this.startDate, this.endDate, rowDayArr, curWeekDay, columns, row, { clickable: true }));
                }
                // mark ranges
                if (this.markRanges_) {
                    this.markRanges_.forEach(mr => {
                        res.push(handleRange(mr.startDate, mr.endDate, rowDayArr, curWeekDay, columns, row, { clickable: mr.clickable, message: mr.message, color: mr.color }));
                    });
                }
                row++;
                rowDayArr = [];
            }
            else {
                curWeekDay++;
            }
        }
        // handle last row
        if (this.dateSelectionMode_ == 'range')
            res.push(handleRange(this.startDate, this.endDate, rowDayArr, firstCol, curWeekDay - 1, row, { clickable: true }));
        // mark ranges
        if (this.markRanges_) {
            this.markRanges_.forEach(mr => {
                res.push(handleRange(mr.startDate, mr.endDate, rowDayArr, curWeekDay, columns, row, { clickable: mr.clickable, message: mr.message, color: mr.color }));
            });
        }
        if (this.hasWeekNo_) {
            if (curWeekDay - 1 !== columns)
                row++;
            for (let w = 2; w < row; w++) {
                res.push(renderWeekNo(currentWeekNo, 1, w));
                //calc weekNo
                let modifier = 0;
                if (firstWeekDayMonth == 1)
                    modifier = 1;
                currentWeekNo = new Date(curYear, curMonth, ((w - 1) * 7) + modifier).getWeek();
            }
            res.push(renderBorder());
        }
        return html `${res}`;
        // weekday helper functions
        function renderWeekNo(iWeekNo, iCol, iRow) {
            return html `
                <div 
                    style="grid-area: ${(iRow)}/${iCol}/${(iRow) + 1}/${(iCol) + 1};"
                    class="weekno">
                    ${iWeekNo}
                </div>
            `;
        }
        function renderBorder() {
            return html `
                <div 
                    style="grid-area: 1/2/8/3" 
                    class="border">
                </div>
            `;
        }
        function handleRange(iStartDate, iEndDate, weekArray, colOffSet, maxCol, iRow, options) {
            let first = 0;
            if (iStartDate && iEndDate) {
                /* stupid shit - handles first week */
                if (weekArray[0] == undefined) {
                    for (let i = 0; i < weekArray.length; i++) {
                        if (weekArray[i] !== undefined) {
                            first = i;
                            break;
                        }
                    }
                }
                switch (dateRangeOverlaps(weekArray[first], weekArray[weekArray.length - 1], iStartDate, iEndDate)) {
                    case 0: // b in a
                        return renderRange(iRow, weekArray.findIndex((x) => { return (x === null || x === void 0 ? void 0 : x.valueOf()) === iStartDate.valueOf(); }) + colOffSet, weekArray.findIndex((x) => { return (x === null || x === void 0 ? void 0 : x.valueOf()) === iEndDate.valueOf(); }) + colOffSet, options);
                    case 1: // b starts in a
                        return renderRange(iRow, weekArray.findIndex((x) => { return (x === null || x === void 0 ? void 0 : x.valueOf()) === iStartDate.valueOf(); }) + colOffSet, maxCol, options);
                    case 2: // b ends in a
                        return renderRange(iRow, colOffSet, weekArray.findIndex((x) => { return (x === null || x === void 0 ? void 0 : x.valueOf()) === iEndDate.valueOf(); }) + colOffSet, options);
                    case 3: // a in b
                        //handle first week of month with range starting in previous month
                        if (weekArray[first].getDate() == 1 && weekArray[first].getDay() !== 1) {
                            return renderRange(iRow, first + colOffSet, maxCol, options);
                        }
                        return renderRange(iRow, colOffSet, maxCol, options);
                }
            }
            return html ``;
        }
        function renderRange(iRow, iStartCol, iEndCol, options) {
            if (options) {
                return html `
                    <div
                        style="grid-area:${iRow}/${iStartCol}/${iRow + 1}/${iEndCol + 1}; ${options.color ? `background-color:${options.color};` : ''}"
                        class="range mark${options.clickable ? ' clickthrough' : ''}">
                    </div>
                    ${options.message ? html `<pic-tooltip>${options.message}</pic-tooltip>` : ''}
                `;
            }
            return html `
                <div 
                    style="grid-area:${iRow}/${iStartCol}/${iRow + 1}/${iEndCol + 1}"
                    class="range">
                </div>
            `;
        }
        function dateRangeOverlaps(a_start, a_end, b_start, b_end) {
            if (a_start <= b_start && b_end <= a_end)
                return 0; // b in a
            if (a_start <= b_start && b_start <= a_end)
                return 1; // b starts in a
            if (a_start <= b_end && b_end <= a_end)
                return 2; // b ends in a
            if (b_start <= a_start && a_end <= b_end)
                return 3; // a in b
            return -1; // no overlap
        }
    }
    renderWeekDay(iDay, iCol, iRow, iDateObj, firstColumn, totalColumns) {
        let cm = this.getDayClass(iDateObj, iCol);
        let ocm = this.getOuterDayClass(iDateObj, iCol, firstColumn, totalColumns);
        return html `
            <div 
                style="grid-area: ${(iRow)}/${iCol}/${(iRow) + 1}/${(iCol) + 1};"
                class=${classMap(ocm)}>
                <div 
                    class=${classMap(cm)} 
                    @click=${(e) => { if (!cm.blocked)
            this.dayClickHandler(e, iDateObj); }}
                    @mouseenter=${() => {
            this.mouseEnterHandler(iDateObj);
        }}
                    >
                    ${iDay}
                </div>
            </div>
        `;
    }
    getOuterDayClass(iDate, iCol, iFirstCol, iTotalCol) {
        var _a, _b;
        let iDate_ = iDate.setHours(0, 0, 0, 0);
        let hovered = false;
        let hs_ = false;
        let he_ = false;
        let cl_ = (_a = this.clickedDate_) === null || _a === void 0 ? void 0 : _a.setHours(0, 0, 0, 0);
        let hd_ = (_b = this.hoveredDate_) === null || _b === void 0 ? void 0 : _b.setHours(0, 0, 0, 0);
        if (this.dateSelectionMode_ == 'range') {
            if (cl_ && hd_) {
                if (hd_ > cl_) {
                    hovered = (iDate_ >= cl_ && iDate_ <= hd_);
                    he_ = (hd_ === iDate_);
                    hs_ = (iDate_ === cl_);
                }
                else {
                    hovered = (iDate_ >= hd_ && iDate_ <= cl_);
                    hs_ = (hd_ === iDate_);
                    he_ = (iDate_ === cl_);
                }
            }
        }
        if (iCol == iFirstCol)
            hs_ = true;
        if (iCol == iTotalCol)
            he_ = true;
        return {
            outer: true,
            hovered: hovered,
            hoverstart: hs_,
            hoverend: he_,
        };
    }
    getDayClass(iDate, iCol) {
        var _a, _b, _c;
        let iDate_ = iDate.setHours(0, 0, 0, 0);
        let startDate_ = (_a = this.startDate) === null || _a === void 0 ? void 0 : _a.setHours(0, 0, 0, 0);
        let endDate_ = (_b = this.endDate) === null || _b === void 0 ? void 0 : _b.setHours(0, 0, 0, 0);
        let cl_ = (_c = this.clickedDate_) === null || _c === void 0 ? void 0 : _c.setHours(0, 0, 0, 0);
        // Check if the date is before today
        let isBeforeToday = iDate_ < startDate_;
        let isAfterToday = iDate_ > endDate_;
        let isNotInRange = false;
        let minDate = new Date(''); // Set minimum date here
        let maxDate = new Date(''); // Set maximum date here
        if (this.parent_ instanceof PICDualDate && this.dateCandidates[0]) {
            let mainDate1 = new Date(this.dateCandidates[0]);
            let mainDate2 = new Date(this.dateCandidates[0]);
            minDate = new Date(mainDate1.setDate(mainDate1.getDate() - this.parent_.maxRange));
            maxDate = new Date(mainDate2.setDate(mainDate2.getDate() + this.parent_.maxRange));
            // Check if the date is before the minimum date or after the maximum date
            if (iDate < minDate || iDate > maxDate) {
                isNotInRange = false; // Date is disabled
            }
        }
        return {
            inner: true,
            weekday: true,
            today: (iDate_ == new Date(Date.now()).setHours(0, 0, 0, 0)),
            selected: (iDate_ == startDate_) || (iDate_ == endDate_),
            clicked: (iDate_ == cl_),
            blocked: checkBlocked(iDate, this),
            'weekday-disabled': isBeforeToday || isAfterToday || isNotInRange // Apply the gray background class
        };
        function checkBlocked(iDate, dpRef) {
            let blocked = false;
            dpRef.blockingRanges_.forEach(mr => { if (dateRangeOverlaps(mr.startDate, mr.endDate, iDate, iDate) !== -1)
                blocked = true; });
            return blocked;
            function dateRangeOverlaps(a_start, a_end, b_start, b_end) {
                if (a_start <= b_start && b_end <= a_end)
                    return 0; // b in a
                if (a_start <= b_start && b_start <= a_end)
                    return 1; // b starts in a
                if (a_start <= b_end && b_end <= a_end)
                    return 2; // b ends in a
                if (b_start <= a_start && a_end <= b_end)
                    return 3; // a in b
                return -1; // no overlap
            }
        }
    }
    mouseEnterHandler(iEnteredDate) {
        if (this.clickedDate_) {
            this.hoveredDate_ = iEnteredDate;
            this.requestUpdate();
        }
    }
    mouseLeaveHandler(e, iEnteredDate) {
        // this.hoveredDate_ = null;
        this.requestUpdate();
    }
    dayClickHandler(e, iNewDate) {
        if (this.dateCandidates.length == 1 && this.parent_ instanceof PICDualDate && this.parent_.maxRange) {
            // Check if the clicked date is disabled
            if (this.isDateDisabled(iNewDate)) {
                this.requestUpdate();
                return; // Don't allow selection of disabled dates
            }
        }
        let isDoneSelection = false;
        let bubblingEvent;
        this.curDispDate_ = new Date(iNewDate);
        this.clickedDate_ = new Date(iNewDate);
        if (this.dateSelectionMode_ == 'range') {
            if (this.dateCandidates.length == 2) {
                this.dateCandidates = [];
            }
            this.startDate = null;
            this.endDate = null;
            this.dateCandidates.push(iNewDate);
            if (this.dateCandidates.length == 2) {
                this.dateCandidates.sort((a, b) => { return a.valueOf() - b.valueOf(); });
                this.startDate = this.dateCandidates[0];
                this.endDate = this.dateCandidates[1];
                this.clickedDate_ = null;
                this.hoveredDate_ = null;
                isDoneSelection = true;
            }
            bubblingEvent = { detail: { dates: this.dateCandidates, clickEvent: e }, bubbles: true, composed: true };
        }
        else {
            this.startDate = new Date(iNewDate);
            bubblingEvent = { detail: { date: this.startDate, clickEvent: e, firstClick: e.ctrlKey }, bubbles: true, composed: true };
        }
        this.dispatchEvent(new CustomEvent('valueselected', bubblingEvent));
        if (this.parent_ instanceof PICDualDate) {
            if (this.parent_.autoclose_ && isDoneSelection) {
                this.handleClose();
            }
        }
        this.requestUpdate();
    }
    isDateDisabled(date) {
        let minDate = new Date(''); // Set minimum date here
        let maxDate = new Date(''); // Set maximum date here
        if (this.parent_ instanceof PICDualDate && this.dateCandidates[0]) {
            let mainDate1 = new Date(this.dateCandidates[0]);
            let mainDate2 = new Date(this.dateCandidates[0]);
            minDate = new Date(mainDate1.setDate(mainDate1.getDate() - this.parent_.maxRange));
            maxDate = new Date(mainDate2.setDate(mainDate2.getDate() + this.parent_.maxRange));
        }
        // Check if the date is before the minimum date or after the maximum date
        if (date < minDate || date > maxDate) {
            return true; // Date is disabled
        }
        return false; // Date is not disabled
    }
    getYearClass(iYear) {
        return {
            year: true,
            selected: (parseInt(iYear) == this.curDispDate_.getFullYear()),
        };
    }
    renderYearPicker() {
        return html `
            <div class="year_grid_container">
                ${repeat(this.years, (year) => year, (year, index) => this.renderYear(year, index))}
            </div>
        `;
    }
    renderYear(iYear, iIdx) {
        return html `
            <div 
                class=${classMap(this.getYearClass(iYear))} 
                style="grid-area: ${iIdx / 4} / ${iIdx % 4} / ${(iIdx / 4) + 1} / ${(iIdx % 4) + 1};" 
                @click=${() => this.setDispYear(iYear)}>
                ${iYear}
            </div>
        `;
    }
    handleClear() {
        this.dispatchEvent(new CustomEvent('clearDateField'));
        this.handleClose();
    }
    getBtnWidth() {
        let styles = [];
        styles.push({ 'width': 'fit-content' });
        styles.push({ 'min-width': 'fit-content' });
        styles.push({ 'max-width': 'fit-content' });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getClearBtnDDStyle() {
        let styles = [];
        styles.push({ 'width': 'fit-content' });
        styles.push({ 'min-width': 'fit-content' });
        styles.push({ 'max-width': 'fit-content' });
        // styles.push({'visibility': 'hidden'} as StyleInfo);
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    renderFooter() {
        return html `
            ${this.removeClearBtn_ ? '' : html `
                <pic-button 
                    width="${(this.textObj.clearAction.length * 12) + 45}px" 
                    etype="text" 
                    density="low" 
                    .action=${this.clearAction} 
                    label=${this.textObj.clearAction}
                    .noPadding=${true}
                    .widthFitContent=${true}
                    style=${this.dateSelectionMode_ === 'range' ? styleMap(this.getClearBtnDDStyle()) : styleMap(this.getBtnWidth())}
                >
                </pic-button>
            `}
            <pic-button 
                width="${(this.textObj.cancelAction.length * 12) + 45}px"
                etype="text" 
                density="low" 
                .action=${this.cancelAction} 
                label=${this.textObj.cancelAction}
                .noPadding=${true}
                .widthFitContent=${true}
                style=${styleMap(this.getBtnWidth())}
            >
            </pic-button>
            <pic-button 
                width="${(this.textObj.confirmAction.length * 12) + 45}px" 
                etype="text" 
                density="low" 
                .action=${this.saveAction} 
                label=${this.textObj.confirmAction}
                .noPadding=${true}
                .widthFitContent=${true}
                style=${styleMap(this.getBtnWidth())}
            >
            </pic-button>
        `;
    }
    isDirectionDown() {
        var _a;
        let isDown = true;
        let parentRect = (_a = this.parent_) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (parentRect) {
            let remain = (window.innerHeight - parentRect.bottom);
            if (remain < 324)
                isDown = false;
            else
                isDown = true;
        }
        return isDown;
    }
    getContainerStyle() {
        var _a, _b;
        let styles = [];
        styles.push({ 'position': 'fixed' });
        if (this.isDirectionDown()) {
            styles.push({ 'bottom': 'unset' });
            styles.push({ 'top': ((_a = this.parent_) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().bottom) + 5 + 'px' });
        }
        else {
            styles.push({ 'top': 'unset' });
            styles.push({ 'bottom': window.innerHeight - ((_b = this.parent_) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top) + 'px' });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    render() {
        var _a, _b;
        //lit sometimes removed px when set inside of html
        let str = `--pic-dpHeight:${((_b = (_a = this.parent_) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().bottom) !== null && _b !== void 0 ? _b : 0) + 5}px`;
        return html `
            ${this.renderCSS(true)}
            <div class=${classMap(this.getPickerClass())} 
                style=${styleMap(this.getContainerStyle())} 
                @click=${(e) => { this.shouldHide = false; }} 
                @animationend=${(e) => {
            this.handleEnd(e);
            if (e.animationName == 'fadeOut')
                this.state_ = 'day';
        }}>
                <div class="header">
                    ${this.renderHeader()}
                </div>
                <div class="body">
                    ${this.renderBody()}
                </div>
                <div class='footer'>
                    ${this.renderFooter()}
                </div>
            </div>
        `;
    }
};
__decorate([
    property({ type: Boolean, attribute: 'hasweekno' })
], PICDatePicker2.prototype, "hasWeekNo_", void 0);
__decorate([
    property({ type: Boolean, attribute: 'removeclearbtn' })
], PICDatePicker2.prototype, "removeClearBtn_", void 0);
__decorate([
    property()
], PICDatePicker2.prototype, "show", void 0);
__decorate([
    state()
], PICDatePicker2.prototype, "state_", void 0);
__decorate([
    property({ attribute: 'dateselectionmode', converter: stringDecoder })
], PICDatePicker2.prototype, "dateSelectionMode_", void 0);
__decorate([
    state()
], PICDatePicker2.prototype, "calendarDisplayMode_", void 0);
PICDatePicker2 = __decorate([
    customElement('pic-datepicker2')
], PICDatePicker2);
export { PICDatePicker2 };
//# sourceMappingURL=PICDatePicker2.js.map